module.exports = __webpack_public_path__ + "img/retailer_nav_green.791f9042.svg";